<template>
    <div id="searchMore" class="search-more">
        <div class="search-more-body">
            <template v-if="!search && recentKeywords.length > 0">
                <section class="keywords-section">
                    <div class="keywords-section-header">
                        <p class="keywords-title">최근 검색어</p>
                        <button type="button" class="keywords-delete" @click.prevent="deleteAllRecentKeyword">전체삭제</button>
                    </div>
                    <ul class="keywords-section-body pills-list">
                        <li v-for="(recentKeyword, index) in recentKeywords" :key="index">
                            <span class="keyword-pill text-overflow-1 position-relative">
                                <button type="button" class="search-keyword" @click.self="goToSearchView(recentKeyword.keyword)">{{recentKeyword.keyword}}</button>
                                <button type="button" class="keyword-cancel position-absolute" @click.self="deleteRecentKeyword(recentKeyword.id)" aria-label="삭제"></button>
                            </span>
                        </li>
                    </ul>
                </section>
            </template>
            <template v-if="!search">
                <section class="keywords-section">
                    <div class="keywords-section-header">
                        <p class="keywords-title">인기 검색어</p>
                    </div>
                    <ul class="keywords-section-body pills-list">
                        <li v-for="(keyword, index) in popularKeywords" :key="index">
                            <span class="keyword-pill keyword-pill--primary text-overflow-1">
                                <button type="button" class="search-keyword" @click.self="goToSearchView(keyword)">{{keyword}}</button>
                            </span>
                        </li>
                    </ul>
                </section>
            </template>
            <!-- 자동검색어 나열 -->
            <template v-if="search">
                <section class="keywords-section">
                    <ul class="keywords-section-body stick-list">
                        <li v-for="(keyword, index) in autoKeywords" :key="index">
                            <button type="button" ref="autoKeyword" class="auto-keyword" @click.prevent="goToSearchView(keyword)">
                                <i  v-for="(char, strIndex) in keyword" :key="strIndex" :class="{'color-primary': search.includes(char)}" >{{char}}</i>
                            </button>
                        </li>
                    </ul>
                </section>
            </template>
        </div>
        <template v-if="autoSaveStatus === 'ON'">
            <div class="search-more-footer" @click="updateAutoSaveStatus('OFF')">자동저장 끄기</div>
        </template>
        <template v-else-if="autoSaveStatus === 'OFF'">
            <div class="search-more-footer" @click="updateAutoSaveStatus('ON')">자동저장 켜기</div>
        </template>
    </div>
</template>

<script>

export default {
    props: {
        search: {
            type: String,
        },
        savedRecentKeyword: {
            type: Array,
        }
    },

    data(){
        return{
            recentKeywords: [],
            popularKeywords: ['스타벅스', '편의점', '뚜레쥬르', '투썸플레이스', '이디야커피', '상품권', 'GS25', '케이크', '초콜릿', '치킨'],
            allKeywords: [],
            autoKeywords: [],
            SEARCH_KEWYORD_KEY: 'searchKeyword',
            autoSaveStatus: 'OFF',
            regExpRemoveSpace: /\s/g, // 공백제거 정규식
        }
    },

    mounted(){
        this.getAutoSaveSatuts();
        this.setDropdownKeywords();
        
        if(this.search){  // 키워드가 유지된 이후 렌더링, 자동 키워드 생성
            this.createAutokeywords();
        }
    },

    watch: {
        search(){  // 자동 키워드 생성
            this.createAutokeywords();
        }
    },

    methods: {
        // 드롭다운 검색어 리스트(배열)에 값 세팅
        setDropdownKeywords() {
            this.autoKeywords = this.allKeywords;

            if(Array.isArray(this.savedRecentKeyword) && this.savedRecentKeyword.length !== 0) {
                this.recentKeywords = this.sortRecentKeywords(this.savedRecentKeyword);
                this.savedRecentKeyword.forEach((value) => {
                    this.autoKeywords.push(value.keyword);
                })
                this.popularKeywords.forEach((popularValue) => {
                    if(!this.autoKeywords.some((autoKeywordValue) => autoKeywordValue === popularValue)) {
                        this.autoKeywords.push(popularValue);
                    }
                })
            }
        },
        // 자동 키워드 생성
        createAutokeywords(){
           const includedKeywords = this.allKeywords.filter(item => item.includes(this.search));
           this.autoKeywords = includedKeywords;
        },


        /**  자동저장 상태 관련  **/
        getAutoSaveSatuts() {
            if(this.$cookies.isKey('autoSaveStatus')) {
                // 자동저장 기능 켜진경우: ON, 꺼진경우: OFF
                this.autoSaveStatus = this.$cookies.get('autoSaveStatus');
            }
        },
        updateAutoSaveStatus(toBeChangeAutoSaveStatus) {
            if(toBeChangeAutoSaveStatus === 'OFF') {
                // 자동저장 기능을 끌 경우 confirm 창 실행
                if (!confirm('검색어 자동저장을 꺼도 기존 기록은 유지됩니다.\n검색어 자동저장을 중지하겠습니까?')) {
                    // 취소(아니오) 버튼 클릭 시 이벤트
                    return;
                } else {
                    // 확인(예) 버튼 클릭 시 이벤트
                    this.setAutoSaveStatusToCookies(toBeChangeAutoSaveStatus);
                }
            } else {
                this.setAutoSaveStatusToCookies(toBeChangeAutoSaveStatus);
            }
        },
        // 자동저장 기능상태 값 조회
        setAutoSaveStatusToCookies(toBeChangeAutoSaveStatus) {
            this.$cookies.set('autoSaveStatus',toBeChangeAutoSaveStatus);
            this.autoSaveStatus = toBeChangeAutoSaveStatus;
        },
        

        // 최근 검색어 날짜 순으로 내림차순 정렬
        sortRecentKeywords(savedRecentKeyword) {
            let tempSavedRecentKeywords = Array.from(savedRecentKeyword);
            return tempSavedRecentKeywords.sort((a, b) => {
                if(a.id < b.id) return 1;
                if(a.id > b.id) return -1;
                if(a.id === b.id) return 0;
            })
        },
        // 최근 검색어 모두 삭제
        deleteAllRecentKeyword(){
          // console.log('로컬스토리지 전체 삭제');
            localStorage.removeItem(this.SEARCH_KEWYORD_KEY);
            this.recentKeywords = [];
        },
        // 최근 검색어 개별 삭제
        deleteRecentKeyword(keywordId) {
            let tempSavedRecentKeywords = Array.from(JSON.parse(localStorage.getItem(this.SEARCH_KEWYORD_KEY)));
            let index = tempSavedRecentKeywords.findIndex((value) => value.id === keywordId);
            if(index > -1) {
                tempSavedRecentKeywords.splice(index, 1)
            }
            typeof(Storage) !== 'undefined' && localStorage.setItem(this.SEARCH_KEWYORD_KEY, JSON.stringify(tempSavedRecentKeywords));
            this.recentKeywords = this.sortRecentKeywords(JSON.parse(localStorage.getItem(this.SEARCH_KEWYORD_KEY)));
        },


        // 선택한 키워드 value 검색화면 이동
        goToSearchView(selectedKeyword){
            // 검색어에 공백이 포함
            if (selectedKeyword.match(this.regExpRemoveSpace)) {
                selectedKeyword = this.removeUnnecessarySpace(selectedKeyword);         // 맨앞 맨뒤 공백 제거
                selectedKeyword = selectedKeyword.replace(this.regExpRemoveSpace, ',');     // 띄어쓰기를 , 로 치환
            }

            // vuex commit 등록
            this.$store.commit('searchStore/setVuexSearch', selectedKeyword);

            // 키워드 검색 후 동일한 키워드 재 검색시 콘솔오류 안뜨게
            this.$router.push({name:"search", query: {data: selectedKeyword}}).catch(()=>{
                // 검색어가 같을 경우 새로고침 처리
                if(this.$route.query.data === selectedKeyword){
                    this.$router.go();
                }
            });
        },

        // 검색어의 다중공백, 앞공백, 뒷공백 제거
        removeUnnecessarySpace(str) {
            let result = '';

            // 다중 공백을 단일 공백으로 치환
            str = str.replace(/ +/g, ' '); 

            // 앞 뒤 공백 제거
            if(str.charAt(0).match(this.regExpRemoveSpace) || str.charAt(str.length - 1).match(this.regExpRemoveSpace) ) {
                result = this.search.replace(/^\s+|\s+$/gm, '');
                return result;
            }else{
                return str;
            }
        },
    },

}
</script>

<style lang="scss" scoped>
@import '@/assets/css/header.scss'; /* Header css */
@import '@/assets/css/product.scss';

    .search-more-body{
        flex: 1;
        overflow: auto;
        display: flex;
        flex-direction: column;
        gap: 36px;
        padding: var(--container-padding);

        .keywords-section{
            display: flex;
            flex-direction: column;
            gap: 20px;

            .keywords-section-header{
                display: flex;
                justify-content: space-between;
                line-height: 1;

                .keywords-title{
                    font-size: 16px;
                    font-weight: 600;
                    color: var(--black);
                }
                .keywords-delete{
                    font-size: 14px;
                    font-weight: 400;
                    color: var(--gray-40);
                    border-bottom: 1px solid currentColor;
                }
            }
            
            .keywords-section-body{
                &.pills-list{
                    display: flex;
                    flex-wrap: wrap;
                    gap: var(--compo-form-inline-pd);
                }

                .keyword-pill{
                    font-weight: 400;
                    line-height: 30px;

                    &.text-overflow-1{
                        min-height: 1rem;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 1; // 1줄에서 말줄임
                        -webkit-box-orient: vertical;
                    }

                    &.position-relative{
                        padding-right: 26px;
                    }
                }

                .keyword-cancel{
                    right: var(--compo-form-inline-pd);
                }
            }
        }

        .auto-keyword{
            width: 100%;
            padding: 14px 0;
            line-height: 1;
            text-align: left;
        }
    }
    
    .search-more-footer{
        padding: 0 var(--container-padding);
        border-top: 1px solid var(--gray-20);
        color: var(--gray-40);
        height: 48px;
        line-height: 48px;
        cursor: pointer;
        font-size: 14px;
    }
    
</style>